import React, { useState, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import { LogoMarquee } from "../../_components/LogoMarquee";
import { FooterV2 } from "../../_components/FooterV2";
import communityManagerHeroImage from "../../assets/female-artisan-folding-arms.jpeg";
import { logEvent } from "helpers/analytics";
import briefcaseIconCircle from "../../assets/briefcase-circle.png";
import moneyIconCircle from "../../assets/money-icon-circle.png";
import smileyFaceIconCircle from "../../assets/smiley-face-icon-circle.png";
import { Helmet } from "react-helmet";
import { CreateImpactWithCommunity } from "../../_components/services-tabs";
//import { AnimatedCounter } from "../../_components/AnimatedCounter";
import { PageSection } from "../../_components/PageSection";
import etiwaTechLogo from "../../assets/partners/logos/etiwa.png";
import honeytreatAcademyLogo from "../../assets/partners/logos/hta.png";
import ishkTolaramFoundationLogo from "../../assets/partners/logos/ishk.svg";
//import goldYouthLogo from "../../assets/partners/logos/gold-youth.png";
import oplAcademyLogo from "../../assets/partners/logos/opl-logo.webp";
import waveLogo from "../../assets/partners/logos/wave-logo.jpeg";
import fsdLogo from "../../assets/partners/logos/fsd-logo.png";
import suitcaseWithSearchIcon from "../../assets/suitcase-with-search-icon.png";
import userWithCheckIcon from "../../assets/user-with-check-icon.png";
import tvPresentationIcon from "../../assets/tv-presentation-icon.png";
import statsIcon from "../../assets/stats-icon.png";
import documentSyncIcon from "../../assets/document-sync-icon.png";
import { CommunitySalesConversationModal } from "../../features/community-sales-conversation";
import { DemoModal } from "../../_components/Modals";
import ClientsFAQs from "_components/clients-landing-pages/ClientsFAQs";
import { communityFAQs } from "../faqs/constants";
import { useHistory, useLocation } from "react-router";

const logos = [
  {
    name: "Etiwa Tech",
    logo: etiwaTechLogo,
  },
  {
    name: "Honeytreat Academy",
    logo: honeytreatAcademyLogo,
  },
  {
    name: "IshK Tolaram Foundation",
    logo: ishkTolaramFoundationLogo,
  },
  {
    name: "OPL Academy",
    logo: oplAcademyLogo,
  },
  // {
  //   name: "Gold Youth",
  //   logo: goldYouthLogo,
  // },
  {
    name: "Wave",
    logo: waveLogo,
  },
  {
    name: "FSD",
    logo: fsdLogo,
  },
];

const storiesStats = [
  {
    title: "80,000 workers matched",
    icon: briefcaseIconCircle,
  },
  {
    title: "25% growth in average earnings",
    icon: moneyIconCircle,
  },
  {
    title: "95% user satisfaction across workers and hiring managers",
    icon: smileyFaceIconCircle,
  },
];

const CommunityManager: React.FC = () => {
  const [isCommunitySalesConversationOpen, setCommunitySalesConversationOpen] =
    useState(false);
  const [isDemoModalOpen, setDemoModalOpen] = useState(false);

  const navigate = useHistory().push;
  const location = useLocation();

  // Training dashboard URL for all CTAs
  const trainingHref = process.env.REACT_APP_TRAINING_URL || "https://training.laborhack.com";

  // Check for query parameter to open modal on page load
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const shouldOpenTalkToSalesModal =
      searchParams.get("talk-to-sales") === "true";

    if (shouldOpenTalkToSalesModal) {
      setCommunitySalesConversationOpen(true);
      logEvent("community_manager/talk_to_sales");
    }
  }, [location.search]);

  const handleWatchDemo = () => {
    logEvent("community_watch_demo_click");
    setDemoModalOpen(true);
  };

  return (
    <div>
      <CommunitySalesConversationModal
        isOpen={isCommunitySalesConversationOpen}
        onClose={() => setCommunitySalesConversationOpen(false)}
      />
      <DemoModal
        isOpen={isDemoModalOpen}
        onClose={() => setDemoModalOpen(false)}
        videoUrl="https://drive.google.com/file/d/1n8pFL2wa2FHsMPa7LbEJVo4WmkLSUq7n/view"
        title="LaborHack Community Manager demo"
      />
      <Helmet>
        <title>
          LaborHack Community Manager - Connect your community with jobs.
        </title>
        <meta
          name="description"
          content="Running an NGO, social enterprise, and community organisation? Give your beneficiaries access to verified job opportunities and track their progress."
        />
      </Helmet>
      {/* Hero Section */}
      <div className="relative w-full h-[500px] md:h-[632px] bg-[#F7F4F4]">
        {/* Background Image with Overlay */}
        <div
          className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${communityManagerHeroImage})`,
          }}
        />

        {/* Dark overlay on the left side */}
        <div
          className="absolute top-0 left-0 w-full md:w-[50vw] h-full"
          style={{ backgroundColor: "rgba(18, 18, 18, 0.3)" }}
        />

        {/* Additional overlay for text readability */}
        <div
          className="absolute top-0 left-0 w-full h-full"
          style={{ backgroundColor: "rgba(49, 28, 28, 0.4)" }}
        />

        {/* Content */}
        <PageSection className="h-full relative z-10">
          <div className="h-full flex items-center">
            <div className="max-w-full md:max-w-[600px]">
              <div className="flex flex-col gap-4 md:gap-8">
                {/* Title and Description */}
                <div className="flex flex-col gap-3 md:gap-4">
                  <h1 className="text-[#F0F0F0] text-[36px] md:text-[56px] font-medium leading-tight md:leading-[1.1428571428571428] tracking-tight">
                    Connect your <br className="hidden md:block" /> community
                    with jobs
                  </h1>

                  <p className="text-[#FEFEFE] text-base md:text-xl font-normal leading-7 max-w-full md:max-w-[500px]">
                    Running an NGO, social enterprise, or community
                    organization? Give your beneficiaries access to verified job
                    opportunities and track their progress.
                  </p>
                </div>

                {/* CTA Button */}
                <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
                  {/* Training Dashboard Link */}
                  <a
                    href={trainingHref}
                    className="bg-[#ED6E5C] text-[#FEFEFE] font-inter font-medium text-base md:text-lg px-6 md:px-10 py-3 md:py-5 h-12 md:h-16 flex items-center justify-center gap-2 hover:bg-[#E55D4B] hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 transition-all duration-200 ease-in-out"
                  >
                    Get Started
                  </a>
                  <button
                    onClick={handleWatchDemo}
                    className="text-[#153243] bg-[#FEFEFE] hover:bg-[#F0F0F0] font-inter font-medium text-base md:text-lg px-6 md:px-10 py-3 md:py-5 h-12 md:h-16 flex items-center justify-center gap-2 hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 transition-all duration-200 ease-in-out"
                  >
                    Watch demo
                    <FaArrowRight size="14" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </PageSection>
      </div>

      <LogoMarquee logos={logos} title="Our Community Partners" />

      {/* TODO: Add community members onboarded counter */}
      {/* <PageSection className="bg-white border-b-[0.5px] border-[#121212]">
        <div className="flex flex-col gap-4 py-16 items-center">
          <h2 className="text-xl font-normal text-prussianBlue-500">
            Community Members Onboarded
          </h2>

          <AnimatedCounter
            target={2900}
            suffix="+"
            className="text-6xl font-semibold font-aeonik text-prussianBlue-900"
          />
        </div>
      </PageSection> */}

      {/* Third Section - Create impact with community */}
      <PageSection className="bg-[#FEFEFE]">
        <CreateImpactWithCommunity ctaHref={trainingHref} ctaLabel="Get Started" />
      </PageSection>

      {/* Fourth Section - Stop losing track of work done. */}
      <PageSection className="w-full bg-[#EEE6F8] py-12 md:py-16 border-b-[0.5px] border-[#121212]">
        <div className="mb-8 md:mb-12">
          <h2 className="text-2xl md:text-[40px] font-medium text-[#040A0D] leading-[1.2] mb-4 font-[AeonikPro]">
            Stop losing track of work done.
          </h2>
          <p className="text-base md:text-xl text-[#464646] leading-[1.6] font-[Inter]">
            Automatically track learning progress and validate completed work by
            your apprentices — no need for paper logbooks
          </p>
        </div>

        <div className="border-t-[0.5px] border-[#121212] pt-8 md:pt-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 mb-8 md:mb-12 border-b-[0.5px] border-[#121212] pb-8 md:pb-12">
            {/* Offer 1 */}
            <div className="flex flex-col gap-3 md:gap-4">
              <div className="w-full flex justify-start">
                <img
                  src={suitcaseWithSearchIcon}
                  alt="Track hands-on experience"
                  className="h-16 lg:h-20"
                />
              </div>
              {/* Text */}
              <div className="flex flex-col gap-2">
                <h3 className="text-lg md:text-[22px] font-medium text-[#212121] leading-[1.318] font-[Inter]">
                  Track hands-on experience with digital logbooks.
                </h3>
              </div>
            </div>

            {/* Offer 2 */}
            <div className="flex flex-col gap-3 md:gap-4 lg:w-[70%]">
              <div className="w-full flex justify-start">
                <img
                  src={userWithCheckIcon}
                  alt="Validate hours"
                  className="h-16 lg:h-20"
                />
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="text-lg md:text-[22px] font-medium text-[#212121] leading-[1.318] font-[Inter]">
                  Validate hours with supervisor sign-offs
                </h3>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 mb-8 md:mb-12 border-b-[0.5px] border-[#121212] pb-8 md:pb-12">
            {/* Offer 3 */}
            <div className="flex flex-col gap-3 md:gap-4">
              {/* Icon */}
              <div className="w-full flex justify-start">
                <img
                  src={tvPresentationIcon}
                  alt="Spot at-risk learners"
                  className="h-16 lg:h-20"
                />
              </div>
              {/* Text */}
              <div className="flex flex-col gap-2">
                <h3 className="text-lg md:text-[22px] font-medium text-[#212121] leading-[1.318] font-[Inter]">
                  Spot at-risk learners with alerts and insights
                </h3>
              </div>
            </div>

            {/* Offer 4 */}
            <div className="flex flex-col gap-3 md:gap-4 lg:w-[70%]">
              <div className="w-full flex justify-start">
                <img
                  src={statsIcon}
                  alt="Sync to LaborPass portfolios"
                  className="h-16 lg:h-20"
                />
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="text-lg md:text-[22px] font-medium text-[#212121] leading-[1.318] font-[Inter]">
                  Sync to LaborPass portfolios for career growth
                </h3>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 mb-8 md:mb-12 pb-8 md:pb-12">
            {/* Offer 5 */}
            <div className="flex flex-col gap-3 md:gap-4">
              {/* Icon */}
              <div className="w-full flex justify-start">
                <img
                  src={documentSyncIcon}
                  alt="Generate reports"
                  className="h-16 lg:h-20"
                />
              </div>
              {/* Text */}
              <div className="flex flex-col gap-2">
                <h3 className="text-lg md:text-[22px] font-medium text-[#212121] leading-[1.318] font-[Inter]">
                  Generate reports for funders or accreditation
                </h3>
              </div>
            </div>
          </div>
        </div>
      </PageSection>

      {/* <PageSection>
        <div className="w-full py-14">
          <div className="border-y border-prussianBlue-300 grid grid-cols-1 md:grid-cols-3 py-16 gap-8">
            <div className="col-span-1">
              <h2 className="text-2xl md:text-4xl font-medium text-gray-900 mb-4 text-center md:text-left">
                Stories that <br className="hidden md:block" /> make a
                difference
              </h2>
            </div>
            <div className="col-span-2 relative overflow-hidden hidden md:block">
              <Marquee autoFill={true} speed={150}>
                {storiesStats.map((story, index) => (
                  <div
                    key={`${story.title}-${index}`}
                    className="flex items-center gap-4 min-w-[360px]  md:min-w-[480px] flex-shrink-0"
                  >
                    <img
                      src={story.icon}
                      alt={story.title}
                      className="w-14 h-14"
                    />
                    <p className="text-lg md:text-2xl text-[#212121] font-[Inter] leading-[1.2916667] max-w-96">
                      {story.title}
                    </p>
                  </div>
                ))}
              </Marquee>
            </div>

            <div className="col-span-1 md:hidden px-5">
              <div className="flex flex-col gap-4">
                {storiesStats.map((story, index) => (
                  <div
                    key={`${story.title}-${index}`}
                    className="flex items-center gap-4"
                  >
                    <img
                      src={story.icon}
                      alt={story.title}
                      className="w-14 h-14"
                    />
                    <p className="text-lg md:text-2xl text-[#212121] font-[Inter] leading-[1.2916667] max-w-96">
                      {story.title}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </PageSection> */}

      <ClientsFAQs
        items={communityFAQs}
        onReadAllFAQs={() => navigate("/faqs?tab=community")}
      />

      {/* Footer */}
      <FooterV2
        ctaTitle="Power your community with real opportunities."
        primaryCtaLabel="Get Started"
        primaryCtaHref={trainingHref}
        secondaryCtaLabel="Watch demo"
        onSecondaryCta={handleWatchDemo}
      />
    </div>
  );
};

export default CommunityManager;
